import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import Toggler from '../../../components/UI/Toggler';
import { setSortMethod } from '../../../redux/actions/selectedPlaceActions';

// CSS
import './sort.css';

class Sorter extends Component {
  render() {
    const { setSortMethod, sortBy, sortOrder } = this.props;

    return (
      <Toggler>
        {({ on, toggle }) => (
          <Dropdown isOpen={on} toggle={toggle} className="dp-plain" direction="down">
            <DropdownToggle>{this.sortButton({ sortBy, sortOrder })}</DropdownToggle>
            <DropdownMenu right>
              <DropdownItem
                className={this.setActive(sortOrder, 'asc')}
                onClick={() => setSortMethod({ sortOrder: 'asc', sortBy: 'name' })}
              >
                Name: A to Z
              </DropdownItem>
              <DropdownItem
                className={this.setActive(sortOrder, 'desc')}
                onClick={() => setSortMethod({ sortOrder: 'desc', sortBy: 'name' })}
              >
                Name: Z to A
              </DropdownItem>
              <DropdownItem
                className={this.setActive(sortOrder, 'none')}
                onClick={() => setSortMethod({ sortOrder: 'none', sortBy: 'none' })}
              >
                None
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        )}
      </Toggler>
    );
  }

  setActive = (type, value) => (type === value ? 'active' : '');

  sortButton = ({ sortOrder, sortBy }) => {
    if (sortBy === 'none') sortBy = 'Sort';
    return (
      <Fragment>
        <span>{sortBy}</span> {this.sortByIcons[sortOrder]}
      </Fragment>
    );
  };

  sortByIcons = {
    none: <i className="icon icon-hg-up-arrow" />,
    asc: <i className="icon icon-hg-up-arrow" />,
    desc: <i className="icon icon-hg-down-arrow" />,
  };
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setSortMethod: ({ sortBy, sortOrder }) => {
      dispatch(
        setSortMethod({
          theme: ownProps.theme,
          sortBy,
          sortOrder,
        })
      );
    },
  };
};

const mapStateToProps = ({ selectedPlace }, ownProps) => {
  const { sortBy, sortOrder } = selectedPlace[ownProps.theme];
  return {
    sortBy,
    sortOrder,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sorter);



// WEBPACK FOOTER //
// ./src/screens/Places/Sorter/Sorter.jsx